import { baseUrl, apiKey } from "../config";

const MatchServices = {
  getMatchById: async (matchId) => {
    try {
      const response = await fetch(`${baseUrl}/matches/${matchId}`, {
        headers: {
          ["x-signature"]: apiKey,
        },
        next: { revalidate: 60 },
      });
      const jsResponse = await response.json();
      return jsResponse?.data;
    } catch (error) {
      console.log(error);
    }
  },
  getMatchAnalysis: async (matchId) => {
    try {
      const response = await fetch(`${baseUrl}/matches/${matchId}/analysis`, {
        headers: {
          ["x-signature"]: apiKey,
        },
        next: { revalidate: 60 },
      });

      if (response.status !== 200) {
        return null;
      }

      const jsResponse = await response?.json();
      return jsResponse;
    } catch (error) {
      console.log(error);
    }
  },
  getMatchFormStats: async (matchId, teamIds) => {
    try {
      const response = await fetch(
        `${baseUrl}/matches/${matchId}/form-stats?teamIds=${teamIds}`,
        {
          headers: {
            ["x-signature"]: apiKey,
          },
          next: { revalidate: 60 },
        }
      );

      if (response?.status !== 200) {
        return null;
      }

      const jsResponse = await response?.json();
      return jsResponse?.data;
    } catch (error) {
      console.log(error);
    }
  },
  getMatchGoalStats: async (matchId) => {
    try {
      const response = await fetch(
        `${baseUrl}/matches/${matchId}/goals-stats`,
        {
          headers: {
            ["x-signature"]: apiKey,
          },
          next: { revalidate: 60 },
        }
      );

      if (response.status !== 200) {
        return null;
      }

      const jsResponse = await response?.json();
      return jsResponse?.data;
    } catch (error) {
      console.log(error);
    }
  },
  getMatchOddStats: async (matchId) => {
    try {
      const response = await fetch(`${baseUrl}/matches/${matchId}/odds-stats`, {
        headers: {
          ["x-signature"]: apiKey,
        },
        next: { revalidate: 60 },
      });

      if (response.status !== 200) {
        return null;
      }

      const jsResponse = await response?.json();
      return jsResponse?.data;
    } catch (error) {
      console.log(error);
    }
  },
  getOddByMatchId: async (matchId) => {
    try {
      const response = await fetch(`${baseUrl}/odd/${matchId}`, {
        headers: {
          ["x-signature"]: apiKey,
        },
        next: { revalidate: 60 },
      });

      const jsResponse = await response.json();
      return jsResponse?.data;
    } catch (error) {
      console.log(error);
    }
  },
  getLiveOddByMatchId: async (matchId) => {
    try {
      const response = await fetch(`${baseUrl}/odd/${matchId}/live`, {
        headers: {
          ["x-signature"]: apiKey,
        },
        next: { revalidate: 60 },
      });
      const jsResponse = await response.json();
      return jsResponse?.data;
    } catch (error) {
      console.log(error);
    }
  },
  getMatchHalfFullAnalysis: async (matchId) => {
    try {
      const response = await fetch(
        `${baseUrl}/matches/${matchId}/half-full-analysis`,
        {
          headers: {
            ["x-signature"]: apiKey,
          },
          next: { revalidate: 60 },
        }
      );
      const jsResponse = await response?.json();
      return jsResponse?.data;
    } catch (error) {
      console.log(error);
    }
  },
  getMatchLineups: async (matchId, homeId, awayId) => {
    try {
      const response = await fetch(
        `${baseUrl}/matches/line-up-last-match?matchId=${matchId}&homeId=${homeId}&awayId=${awayId}`,
        {
          headers: {
            ["x-signature"]: apiKey,
          },
          next: { revalidate: 60 },
        }
      );
      const jsResponse = await response.json();
      return jsResponse;
    } catch (error) {
      console.log(error);
    }
  },
  getMatchLatest: async (matchId, homeId, awayId) => {
    try {
      const response = await fetch(
        `${baseUrl}/matches/last-matches?homeId=${homeId}&awayId=${awayId}&matchId=${matchId}`,
        {
          headers: {
            ["x-signature"]: apiKey,
          },
          next: { revalidate: 60 },
        }
      );
      const jsResponse = await response.json();
      return jsResponse?.data;
    } catch (error) {
      console.log(error);
    }
  },
  getMatchStanding: async (leaugeId, homeId, awayId) => {
    try {
      const response = await fetch(
        `${baseUrl}/standing?leagueId=${leaugeId}&teamIds=${homeId},${awayId}`,
        {
          headers: {
            ["x-signature"]: apiKey,
          },
          next: { revalidate: 60 },
        }
      );
      const jsResponse = await response.json();
      return jsResponse?.data?.result ?? [];
    } catch (error) {
      console.log(error);
    }
  },
  getMatchComparison: async (matchId) => {
    try {
      const response = await fetch(
        `${baseUrl}/matches/${matchId}/strength-comparison`,
        {
          headers: {
            ["x-signature"]: apiKey,
          },
          next: { revalidate: 60 },
        }
      );
      const jsResponse = await response.json();
      return jsResponse?.data ?? null;
    } catch (error) {
      console.log(error);
    }
  },
};

export default MatchServices;
